// client/src/components/learning/SimulationModule.tsx
import React from "react";
import { LessonSegment } from "../../types/learning";

interface SimulationModuleProps {
  moduleData: LessonSegment;
  onComplete: (moduleId: string, data?: any) => void;
}

const SimulationModule: React.FC<SimulationModuleProps> = ({ moduleData, onComplete }) => {
  return (
    <div>
      <h2>{moduleData.title} - Simulation</h2>
      <p>{moduleData.content}</p>
      <button onClick={() => onComplete(moduleData.id, { simulationResult: "success" })}>
        Complete Simulation
      </button>
    </div>
  );
};

export default SimulationModule;
